export const APP_LOCALE = process.env.VUE_APP_LOCALE || 'en';
export const APP_DIRECTION = process.env.VUE_APP_DIRECTION || 'ltr';
export const APP_GTAG_DEBUGGER = process.env.APP_GTAG_DEBUGGER || true;
